import React, { useCallback, useEffect, useState } from 'react';
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";

import image1 from '../assest/banner/img1.webp';
import image2 from '../assest/banner/img2.webp';
import image3 from '../assest/banner/img3.jpg';
import image4 from '../assest/banner/img4.jpg';
import image5 from '../assest/banner/img5.webp';

import image1Mobile from '../assest/banner/img1_mobile.jpg';
import image2Mobile from '../assest/banner/img2_mobile.jpg';
import image3Mobile from '../assest/banner/img3_mobile.jpg';
import image4Mobile from '../assest/banner/img4_mobile.jpg';
import image5Mobile from '../assest/banner/img5_mobile.jpg';

const BannerProduct = () => {
  const [currentImage, setCurrentImage] = useState(0);

  const desktopImages = [
    image1,
    image2,
    image3,
    image4,
    image5
  ];

  const mobileImages = [
    image1Mobile,
    image2Mobile,
    image3Mobile,
    image4Mobile,
    image5Mobile
  ];

  const nextImage = useCallback(() => {
    if (desktopImages.length - 1 > currentImage) {
      setCurrentImage(prev => prev + 1);
    }
  }, [currentImage, desktopImages.length]);

  const prevImage = () => {
    if (currentImage !== 0) {
      setCurrentImage(prev => prev - 1);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (desktopImages.length - 1 > currentImage) {
        nextImage();
      } else {
        setCurrentImage(0);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [currentImage, desktopImages.length, nextImage]);

  return (
    <div className='container mx-auto px-4 rounded'>
      <div className='h-56 md:h-72 w-full bg-slate-200 relative'>
        {/* Navigation buttons */}
        <div className='absolute z-10 h-full w-full md:flex items-center hidden'>
          <div className='flex justify-between w-full text-2xl'>
            <button
              onClick={prevImage}
              className='bg-white shadow-md rounded-full p-1 hover:bg-gray-100 transition-colors'
              aria-label="Previous image"
            >
              <FaAngleLeft />
            </button>
            <button
              onClick={nextImage}
              className='bg-white shadow-md rounded-full p-1 hover:bg-gray-100 transition-colors'
              aria-label="Next image"
            >
              <FaAngleRight />
            </button>
          </div>
        </div>

        {/* Desktop and tablet version */}
        <div className='hidden md:flex h-full w-full overflow-hidden'>
          {desktopImages.map((imageUrl, index) => (
            <div
              className='w-full h-full min-w-full min-h-full transition-all'
              key={`desktop-${index}`}
              style={{ transform: `translateX(-${currentImage * 100}%)` }}
            >
              <img
                src={imageUrl}
                alt={`Banner ${index + 1}`}
                className='w-full h-full object-cover'
              />
            </div>
          ))}
        </div>

        {/* Mobile version */}
        <div className='flex h-full w-full overflow-hidden md:hidden'>
          {mobileImages.map((imageUrl, index) => (
            <div
              className='w-full h-full min-w-full min-h-full transition-all'
              key={`mobile-${index}`}
              style={{ transform: `translateX(-${currentImage * 100}%)` }}
            >
              <img
                src={imageUrl}
                alt={`Banner ${index + 1}`}
                className='w-full h-full object-cover'
              />
            </div>
          ))}
        </div>

        {/* Indicator dots */}
        <div className='absolute bottom-4 left-0 right-0 flex justify-center gap-2'>
          {desktopImages.map((_, index) => (
            <button
              key={`indicator-${index}`}
              onClick={() => setCurrentImage(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                currentImage === index
                  ? 'bg-white w-8'
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BannerProduct;